import Loading from '@/components/Loading';
import AuthGuard from '@/components/SidePanel/AuthGuard';
import FormSubmissionGuard from '@/components/SidePanel/FormSubmissionGuard';
import FormSubmittedPage from '@/pages/dashboard/user/formSubmissionPage/FormSubmittedPage';
import UserDynamicForm from '@/pages/dashboard/user/userDynamicForm/UserDynamicForm';
const UserDashboard = lazy(() => import('../../pages/dashboard/user/UserDashboard'));
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const UserRoutes: RouteObject[] = [
  {
    path: '/user/dashboard/',
    element: (
      <AuthGuard allowedRoles={['user']}>
        <Suspense fallback={<Loading />}>
          <UserDashboard />
        </Suspense>
      </AuthGuard>
    ),
    children: [
      {
        path: ':sectionSlug',
        element: <UserDynamicForm />,
      },
      {
        path: 'form-submission',
        element: (
          <FormSubmissionGuard>
            <FormSubmittedPage />
          </FormSubmissionGuard>
        ),
      },
    ],
  },
];

export default UserRoutes;
